import { Button, Divider, Paper, Stack, Tooltip, Typography } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { selectTenantInfo } from '@sophocles/features/tenant/slice';

function ProjectCard({ jobConfiguration, hideFixtureSwap = true, hideBilling = true, showTooltipInfo = false }) {
  const tenantInfo = useSelector(selectTenantInfo);
  const projectId = _.get(jobConfiguration, ['id'], null);
  const customerId = _.get(jobConfiguration, ['customer', 'id'], null);

  if (!customerId || !projectId) {
    return null;
  }

  const customerName = _.get(jobConfiguration, ['customer', 'name'], `Unknown ${tenantInfo.customer_term}`);

  const customerTitle = <Typography variant="h5">{customerName}</Typography>;

  return (
    <Paper
      sx={{
        width: '100%',
        p: 4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <Typography variant="caption">{tenantInfo.customer_term}</Typography>
      {showTooltipInfo ? (
        <Tooltip
          title={
            <span style={{ textAlign: 'center' }}>
              <div>
                {tenantInfo.customer_term} ID: {customerId}
              </div>
              <div>Project ID: {projectId}</div>
            </span>
          }
        >
          {customerTitle}
        </Tooltip>
      ) : (
        customerTitle
      )}
      {!hideBilling && (
        <Button component={Link} to={`/services/customer/${customerId}/prices/`}>
          Manage Services
        </Button>
      )}
      <Divider sx={{ my: 4 }} />
      <Stack spacing={1} sx={{ width: '100%' }}>
        <Button variant="outlined" component={Link} to={`/services/customer/${customerId}/project/${projectId}/`}>
          Work Forms
        </Button>
        {!hideBilling && (
          <Button
            variant="outlined"
            component={Link}
            to={`/services/customer/${customerId}/project/${projectId}/billing/`}
          >
            Billing
          </Button>
        )}
      </Stack>
    </Paper>
  );
}

ProjectCard.propTypes = {
  jobConfiguration: PropTypes.object,
  hideBilling: PropTypes.bool,
};

export default ProjectCard;
